import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import {
    CommunicationServicesState,
    fetchCommunicationServices,
    selectCommunicationServicesState,
} from "../model"
import { CommunicationMetricCard } from "./communication-metric-card"
import { getMetricEntries } from "./metric-presentations"

interface CommunicationServicesViewProps {
    state: CommunicationServicesState
    onRetry: () => void
}

export const CommunicationServicesView = ({ state, onRetry }: CommunicationServicesViewProps) => {
    if (state.status === "idle" || state.status === "loading") {
        return (
            <section className="mt-8 min-w-0" aria-labelledby="communication-services-heading">
                <h2 id="communication-services-heading" className="mb-4 text-xl font-semibold text-color-dark">
                    Сервисы коммуникации
                </h2>
                <p role="status" aria-live="polite">Статистика сервисов коммуникации загружается</p>
            </section>
        )
    }

    if (state.status === "failed" || !state.data) {
        return (
            <section className="mt-8 min-w-0" aria-labelledby="communication-services-heading">
                <h2 id="communication-services-heading" className="mb-4 text-xl font-semibold text-color-dark">
                    Сервисы коммуникации
                </h2>
                <div role="alert">
                    <p>Не удалось загрузить статистику сервисов коммуникации.</p>
                    {state.error?.message && <p>{state.error.message}</p>}
                    <button type="button" className="btn mt-4" onClick={onRetry}>Повторить</button>
                </div>
            </section>
        )
    }

    return (
        <section className="mt-8 min-w-0" aria-labelledby="communication-services-heading">
            <h2 id="communication-services-heading" className="mb-4 text-xl font-semibold text-color-dark">
                Сервисы коммуникации
            </h2>
            <div className="grid min-w-0 grid-cols-1 gap-4 lg:grid-cols-2">
                {getMetricEntries(state.data).map(({ presentation, metric }) => (
                    <CommunicationMetricCard
                        key={presentation.key}
                        presentation={presentation}
                        metric={metric}
                    />
                ))}
            </div>
        </section>
    )
}

export const CommunicationServices = () => {
    const dispatch = useAppDispatch()
    const state = useAppSelector(selectCommunicationServicesState)

    useEffect(() => {
        if (state.status === "idle") {
            dispatch(fetchCommunicationServices())
        }
    }, [dispatch, state.status])

    return (
        <CommunicationServicesView
            state={state}
            onRetry={() => dispatch(fetchCommunicationServices())}
        />
    )
}
